import { render } from "./PicInput.vue?vue&type=template&id=2f4263fd&scoped=true"
import script from "./PicInput.vue?vue&type=script&lang=js"
export * from "./PicInput.vue?vue&type=script&lang=js"

import "./PicInput.vue?vue&type=style&index=0&id=2f4263fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4263fd"]])

export default __exports__